import * as R from 'ramda'

export const assetValidatorSelector = partner => {
  return R.path(['partner', partner, 'assetValidator'])
}
